module.exports = __webpack_public_path__ + "assets/mp3/audio4/audio_4_2.mp3";